import gettext from '@sdk/lang/gettext';
import Button from '@sdk/components/ui/buttons/Button';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import { ActionsWrapper } from '@web/conversations/ComposeConversation/ComposeConversationActions/composeConversationActions.styles';

type Props = {
  isFormDirty: boolean;
  isFormValid: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel?: string;
};

export const ComposeConversationActions = ({
  isFormValid,
  onCancel,
  onSubmit,
  submitLabel,
}: Props) => (
  <ActionsWrapper>
    <Button onClick={onCancel}>{gettext('Cancel')}</Button>

    <Button
      height={38}
      buttonType={isFormValid ? ButtonType.primary : ButtonType.disabledStyle}
      onClick={onSubmit}>
      {submitLabel || gettext('Save')}
    </Button>
  </ActionsWrapper>
);
